import { adminApi } from "../../../api/adminClient";
import { cloneFormData, unwrapList, unwrapOne } from "../utils/adminApiHelpers";

export { unwrapList, unwrapOne };

export function buildPartnerFormData(data) {
  const fd = new FormData();
  fd.append("name_ar", String(data.name_ar ?? "").trim());
  fd.append("name_en", String(data.name_en ?? "").trim());
  const list = data.logo;
  const file =
    list && typeof list.length === "number" && list.length > 0
      ? list[0]
      : null;
  if (file instanceof File && file.size > 0) {
    fd.append("logo", file);
  }
  return fd;
}

export function buildPartnerFormDataForUpdate(data) {
  const fd = buildPartnerFormData(data);
  fd.append("name[ar]", String(data.name_ar ?? "").trim());
  fd.append("name[en]", String(data.name_en ?? "").trim());
  return fd;
}

export const fetchPartnerList = () => adminApi.get("/partners");

export const fetchPartnerById = (id) => adminApi.get(`/admin/partners/${id}`);

export const createPartner = (formData) =>
  adminApi.post("/admin/partners", formData);

export const updatePartner = (id, formData) => {
  const fd = cloneFormData(formData);
  fd.append("_method", "PUT");
  return adminApi.post(`/admin/partners/${id}`, fd);
};

export const deletePartner = (id) =>
  adminApi.delete(`/admin/partners/${id}`);
